import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
// const Tab = ({ label, onClick, isActive }) => {
//   return (
//     <a
//       href="#"
//       onClick={onClick}
//       className={`shrink-0 border-b-2 px-1 pb-4 text-sm font-medium ${isActive
//         ? 'border-green-500 text-green-600'
//         : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
//         }`}
//     >
//       {label}
//     </a>
//   );
// };
const Tab = ({ label, onClick, isActive }) => {
  return (
    <button
      onClick={onClick}
      className={`shrink-0 border-b-2 px-1 pb-4 text-sm font-medium focus:outline-none ${
        isActive
          ? 'border-green-500 text-green-600'
          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
      }`}
    >
      {label}
    </button>
  );
};


const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  
  var result = data.find(item => item.id === id);
  
  const [activeTab, setActiveTab] = useState('1');

  const handleTabClick = (label) => {
    setActiveTab(label);
  };
  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;

   

  return (
    <>
      <style>{style}</style>

      <Modal className="relative bg-white pl-2 pt-2 pb-2 pr-2 w-1/2" isOpen={isViewModalOpen} onClose={()=>{
        setActiveTab("1");
        closeModal()}} >


        <ModalBody className="custom-modal">

          <div>
            <div className="sm:hidden">
              <label htmlFor="Tab" className="sr-only">
                Tab
              </label>
              <select
                id="Tab"
                className="w-full rounded-md border-gray-200"
                onChange={(e) => handleTabClick(e.target.value)}
                value={activeTab}
              >
                <option value="1">{title}</option>
              </select>
            </div>

            <div className="hidden sm:block">
              <div className="border-b border-gray-200">
                <nav className="-mb-px flex gap-6" aria-label="Tabs">
                  <Tab
                    label={title}
                    onClick={() => handleTabClick('1')}
                    isActive={activeTab === '1'}
                  />
                 
                </nav>
              </div>
            </div>

            {/* Tab Content */}
            <div className="p-4 max-h-96 overflow-y-auto">
              {activeTab === '1' &&
                <div className="border border-gray-100"
                style={{ maxHeight: "400px" }}>
                  <dl className="-my-3 divide-y divide-gray-100 text-sm">
                   
    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
      <dt className="font-medium text-gray-900">Vendor Name</dt>
      <dd className="text-gray-700 sm:col-span-2 pl-20 ">{result?.vendor_name}</dd>
    </div>

    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
      <dt className="font-medium text-gray-900">Driver Name</dt>
      <dd className="text-gray-700 sm:col-span-2 pl-20">{result?.driver_name}</dd>
    </div>

    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
      <dt className="font-medium text-gray-900">Driver Image</dt>
      <dd className="text-gray-700 sm:col-span-2 pl-20">
        <img
          style={{ objectFit: "contain", width: "100px", height: "100px" }}
          src={`${process.env.REACT_APP_API_IMAGE_URL}${result?.driver_img}`}
          alt="Driver License"
        />
      </dd>
    </div>

    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
      <dt className="font-medium text-gray-900">Mobile</dt>
      <dd className="text-gray-700 sm:col-span-2 pl-20">{result?.driver_contact_no}</dd>
    </div>
    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
      <dt className="font-medium text-gray-900">City</dt>
      <dd className="text-gray-700 sm:col-span-2 pl-20">
      {result?.city}</dd>
    </div>
    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
      <dt className="font-medium text-gray-900">Driver Licence</dt>
      <dd className="text-gray-700 sm:col-span-2 pl-20">
      {result?.driving_license}</dd>
    </div>

    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
      <dt className="font-medium text-gray-900">Driver Licence Image</dt>
      <dd className="text-gray-700 sm:col-span-2 pl-20">
        <img
          style={{ objectFit: "contain", width: "100px", height: "100px" }}
          src={`${process.env.REACT_APP_API_IMAGE_URL}${result?.license_img}`}
          alt="Driver License"
        />
      </dd>
    </div>
    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
    <dt className="font-medium text-gray-900">Driver Adhaar</dt>
    <dd className="text-gray-700 sm:col-span-2 pl-20">
    {result?.aadhaar_no}</dd>
  </div>
  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
  <dt className="font-medium text-gray-900">Rating</dt>
  <dd className="text-gray-700 sm:col-span-2 pl-20">
  {result?.driver_rating}</dd>
</div>

<div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
  <dt className="font-medium text-gray-900">Active Status</dt>
  <dd className="text-gray-700 sm:col-span-2 pl-20">
    {result?.status === 0 ? 'Activate' : 'Deactivate'}
  </dd>
</div>

<div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
  <dt className="font-medium text-gray-900">Block Status</dt>
  <dd className="text-gray-700 sm:col-span-2 pl-20">
    {result?.is_blocked === 1 ? 'Blocked' : 'Unblocked'}
  </dd>
</div>


<div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
<dt className="font-medium text-gray-900">Created Date</dt>
<dd className="text-gray-700 sm:col-span-2 pl-20">
{((result)?result["added_date"]:"")}</dd>
</div>

<div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
<dt className="font-medium text-gray-900">Updated Date</dt>
<dd className="text-gray-700 sm:col-span-2 pl-20">
{((result)?result["updated_date"]:"")}</dd>
</div>
  </dl>
</div> }
            </div>
          </div>

        </ModalBody>

      </Modal>

    </>

  );
};

export default React.memo(ViewModal);

